import { IApiRequest } from '@/gateway/axios/IApiRequest'
import { sentbizApi } from '@/gateway/axios'

export interface GetRemittanceGroups extends IApiRequest {
  getInstance (): GetRemittanceGroups;
  request (data: any): Promise<any>;
}

export class GetRemittanceGroups implements GetRemittanceGroups {
  private static instance: GetRemittanceGroups
  private constructor () {}
  public static getInstance (): GetRemittanceGroups {
    if (!this.instance) this.instance = new GetRemittanceGroups()
    return this.instance
  }

  async request (data: any): Promise<any> {
    const requestOption: RequestOption = {
      url: 'remittance/groups',
      method: 'post',
      data
    }
    const response = await sentbizApi.request(requestOption)
    return response
  }
}
